import { render, staticRenderFns } from "./HighlightForm.vue?vue&type=template&id=81a018ba"
import script from "./HighlightForm.vue?vue&type=script&lang=js"
export * from "./HighlightForm.vue?vue&type=script&lang=js"
import style0 from "./HighlightForm.vue?vue&type=style&index=0&id=81a018ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports